import { Injectable } from '@angular/core';
import {Priorities, Statuses, Task} from "../entities/Task";
import {GantChart} from "../entities/GantChart";
import {Resource} from "../entities/Resource";
import {ResourceTaskTime} from "../entities/ResourceTaskTime";
import * as moment from "moment";
import {environment} from "../../environments/environment";
import {Job} from "../entities/Job";
import {JobCalendar} from "../entities/JobCalendar";
import {forEach} from "@angular/router/src/utils/collection";
import {ColorCodes} from "./converter.service";

@Injectable()
export class JobConverterService {

  Priorities = Priorities;
  Statuses = Statuses;

  JobArray : Job[];
  Colors = ['#FF4118',
    '#F1EE00',
    '#00DA0A',
    '#00DAD0',
    '#2E4053',
    '#004CDA',
    '#9F00DA',
    '#DA00AC',
    '#138D75',
    '#DA000D'];

  constructor() { }

  convertFromResponsibleJobsToCalendar(jobs : Job[], responsibles : Resource[]) : JobCalendar {
    this.JobArray = jobs;
    let resources: Resource[];
    resources = [];
    let placedEvents: ResourceTaskTime[];
    placedEvents = [];

    let jobCalendar = new JobCalendar();

    for(let re of responsibles) {

      for (let j of jobs.filter(x => x.SalesPersonRef == re.No)) {

        // Make the JobTask
        let jobTask = this.ConvertToResource(j, re);
        resources.push(jobTask);

        let sdate = moment(j.start);
        let edate = moment(j.end);

        // Make the PlacedTask
        if (edate.utc().format(environment.FULL_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_FULL || j.end == environment.DEFAULT_DATETIME_START) {
          j.end = null;
        }
        if (sdate.utc().format(environment.FULL_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_FULL || j.start == environment.DEFAULT_DATETIME_START) {
          j.start = null;
        }


        if (j.start != null && j.end != null) {

          let placedTask = this.ConvertToPlacedEvent(j, re);

          placedEvents.push(placedTask);
        }
        else {
          //externalTasks.push(t);
        }
      }
    }
    jobCalendar.PlacedEvents = placedEvents;
    jobCalendar.Resources = resources;
    return jobCalendar;
  }


  /*convertFromJobToCalendar(jobs : Job[]) : JobCalendar {
    this.JobArray = jobs;
    //let externalTasks: Task[];
    //externalTasks = [];
    let resources: Resource[];
    resources = [];
    let placedEvents: ResourceTaskTime[];
    placedEvents = [];

    let jobCalendar = new JobCalendar();

    for (let j of jobs) {

      // Make the JobTask
      //let jobTask = this.ConvertToResource(j);
      //resources.push(jobTask);
      let constraint = this.ConvertToConstraint(j);
      //let progress = this.ConvertToProgress(t);
      //placedEvents.push(constraint);
      //placedTasks.push(progress);


      let sdate = moment(j.start);
      let edate = moment(j.end);

      // Make the PlacedTask
      if (edate.utc().format(environment.FULL_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_FULL || j.end == environment.DEFAULT_DATETIME_START) {
        j.end = null;
      }
      if (sdate.utc().format(environment.FULL_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_FULL || j.start == environment.DEFAULT_DATETIME_START) {
        j.start = null;
      }


      if(j.start != null && j.end != null) {

        let placedTask = this.ConvertToPlacedEvent(j);

        placedEvents.push(placedTask);
      }
      else
      {
        //externalTasks.push(t);
      }
    }
    jobCalendar.PlacedEvents = placedEvents;
    jobCalendar.Resources = resources;
    return jobCalendar;
  }*/


  private ConvertToResource(j : Job, r : Resource) : Resource
  {
    let resource = new Resource();
    resource.id = j.No;
    resource.No = j.No;
    resource.title = j.No;
    resource.groupId = r.Name;
    resource.Name = j.No;
    resource.Is_Expanded = false;

    resource.Description = j.Description;
    resource.Title = j.No;
    resource.Customer = j.Bill_to_Name;
    resource.start = j.start;
    resource.end = j.end;
    return resource;
  }

  private ConvertToPlacedEvent(j : Job, re : Resource) : ResourceTaskTime
  {
    let placedEvent = new ResourceTaskTime();
    placedEvent.resourceId = j.No;
    placedEvent.id = j.No;
    placedEvent.Title = j.No;
    placedEvent.title = j.No + " - " +  j.Bill_to_Name;
    placedEvent.TaskRef = j.No;
    placedEvent.constraint = {resourceIds: [j.No]};
    placedEvent.Description = j.Description;
    placedEvent.HasBeenPlannedOn = j.HasBeenPlannedOn;

    placedEvent.color = ColorCodes[re.ColorCode];


    placedEvent.Customer = j.Bill_to_Name;
    //placedEvent.editable = true;

    let sdate = moment(j.start);
    let edate = moment(j.end);

    let e = new Date(j.end);

    // Hvis tidspunktet i startsdatoen er == 00:00:00, gør følgende.
    if (sdate.format(environment.END_DATETIME_FORMAT) == environment.DEFAULT_DATETIME_END) {
      placedEvent.start = sdate.format(environment.START_DATETIME_FORMAT);
      // Set the end date one day forward. because the calendar dosent include the last.
      edate = moment(e.setDate(e.getDate() + 1));
      placedEvent.end = edate.format(environment.START_DATETIME_FORMAT);
    }
    else {
      placedEvent.start = sdate.format(environment.FULL_DATETIME_FORMAT);

      placedEvent.end = edate.format(environment.FULL_DATETIME_FORMAT);
    }
    return placedEvent;
  }

  public ConvertToConstraint(j: Job) : ResourceTaskTime
  {
    let constraint = new ResourceTaskTime();
    constraint.id = j.No;
    constraint.start =  j.start;
    constraint.end =  j.end;
    constraint.color = '#cccccc';
    constraint.rendering = 'background';
    constraint.resourceId = j.No;
    return constraint;
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/job-converter.service.ts